import React from "react"

import CareersJob from "./CareersJob"

export default function CareersJobOpenings({ header, contentfulid, items }) {
  return (
    <section id={contentfulid} className={`pb-12`}>
      <div className="w-full">
        {header && (
          <h2 className="text-4xl md:text-5xl mb-8 leading-normal text-secondary uppercase md:mr-auto w-fit">
            {header}
          </h2>
        )}
        {items.length ? (
          <div className="grid lg:grid-cols-2 2xl:grid-cols-3 gap-y-4 md:gap-y-16 gap-x-8 mx-auto w-fit">
            {items.map((item, index) => (
              <CareersJob key={`job-${index}`} {...item} />
            ))}
          </div>
        ) : (
          <p>
            There are currently no positions available. Please check back at a
            later date.
          </p>
        )}
      </div>
    </section>
  )
}
